/**
 * 回复一条评论
 * @param comment_id 回复的评论ID
 * @param content 评论内容
 * @returns 发送成功的评论
 */
export async function requestCreateCommentReply(
  comment_id: number,
  content: string
) {
  return http.post('/v1/comment/create_reply', {
    comment_id,
    content
  })
}
